<div class="ir-load-spinner-container" *ngIf="show">
  <div class="ir-load-spinner">
    <div class="rect rect1"></div>
    <div class="rect rect2"></div>
    <div class="rect rect3"></div>
    <div class="rect rect4"></div>
    <div class="rect rect5"></div>
  </div>
</div>
